import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blanks',
  templateUrl: './blanks.component.html',
  styleUrls: ['./blanks.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlanksComponent implements OnInit {
  constructor() {}

  public ngOnInit() {}
}
